import {Injectable} from '@angular/core';
import {Shelf} from "../model/shelf.model";
import {FilterParams, RepositoryService} from "../../../helpers/crud/repository.service";
import {WancomHttpService} from "../../../services/wancom-http/wancom-http.service";
import {WaitingService} from "../../layout/waiting/waiting.service";

@Injectable({
	providedIn: 'root'
})
export class ShelfService extends RepositoryService<Shelf> {
	constructor(http: WancomHttpService, waiting$: WaitingService) {
		super(http, waiting$, 'shelf');
	}

	getBreadCrumb(shelfId: number) {
		return this.http.get<Shelf[]>(`${this.url}/rename/${shelfId}`);
	}

	setMedialibShelf(shelfId: number, mediaLibraryId: number){
		return this.http.post(`${this.url}/setMediaLibShelf/${mediaLibraryId}/${shelfId}`,[]);

	}
}

export class ShelfsParams extends FilterParams {
	onlyWithProduct?: boolean;
	onlyWithSpot?: boolean;
}
